import React, {useState} from "react";
import {Box, Button, Column, Columns, Title} from "@allxsmith/bestax-bulma";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import {createSetDataFreshAction} from "../../../actions/dataActions";
import {ToastContainer, toast} from "react-toastify";
import {useDispatch} from "react-redux";


function NewJobWorkshopTab(dataFresh){
    const [typeahead, setTypeahead] = useState();
    const [, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    let [supplier, setSupplier] = useState();
    const dispatch = useDispatch();

    const save = () => {
        const endpoint = "api/contacts/"+supplier.id;
        const conf ={
            method: "put",
            data: supplier,
            url: endpoint
        }

        return axios(conf).then((resp) => {
            dispatch(createSetDataFreshAction(dataFresh +1));
        }).catch(err => {toast.error("An error occurred!", {position: "top-right"})});
    }

    const onClick = (e) => {
        supplier.job_tab = true;
        save().then((resp) => {setSupplier("")}).catch(err => {toast.error("An error occurred!", {position: "top-right"})});
    }
    const handleCustomerSelect = (e) => {
        setSupplier(e[0]);
    }
    const handleSearch = query => {
        setLoading(true);
        axios.get(`api/suppliers?&search=${query}`).then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
        });
    };

    return (
        <div>
            <Box>
                <details>
                    <summary><Title>Add Job Workshop Tab</Title></summary>
                    <Columns isMultiline>
                        <Column>
                        <AsyncTypeahead
                            useCache={false}
                            isLoading={false}
                            id="typeahead"
                            labelKey="display_name"
                            minLength={2}
                            name={"display_name"}
                            onSearch={handleSearch}
                            onChange={handleCustomerSelect}
                            placeholder={`Search Workshop`}
                            selected={supplier ? [supplier] : []}
                            options={searchData}
                            ref={typeahead => setTypeahead(typeahead)}
                            className="typeahead"
                        />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                        <Button
                            color={"success"}
                            onClick={onClick}
                            isFullWidth
                        >
                            Add
                        </Button>
                        </Column>
                    </Columns>
                </details>
            </Box>
        </div>
    );




}
export default NewJobWorkshopTab;